export var PlaybackEvent;
(function (PlaybackEvent) {
    PlaybackEvent["CONTENT_DELETED"] = "CONTENT_DELETED";
    PlaybackEvent["START"] = "START";
    PlaybackEvent["PAUSE"] = "PAUSE";
    PlaybackEvent["STOP"] = "STOP";
    PlaybackEvent["RESTART"] = "RESTART";
    PlaybackEvent["SCRUB"] = "SCRUB";
    PlaybackEvent["JUMP_FORWARD"] = "JUMP_FORWARD";
    PlaybackEvent["JUMP_BACKWARD"] = "JUMP_BACKWARD";
    PlaybackEvent["SET_PLAYBACK_RATE"] = "SET_PLAYBACK_RATE";
    PlaybackEvent["ENTITLEMENT_ERROR"] = "ENTITLEMENT_ERROR";
    PlaybackEvent["UNKOWN_ERROR"] = "UNKOWN_ERROR";
    PlaybackEvent["PROGRESS_UPDATED"] = "PROGRESS_UPDATED";
    PlaybackEvent["ACTIVE_PLAYLIST_CONTEXT_UPDATED"] = "ACTIVE_PLAYLIST_CONTEXT_UPDATED";
    PlaybackEvent["ATTEMPT_ADVANCE_PLAYLIST"] = "ATTEMPT_ADVANCE_PLAYLIST";
    PlaybackEvent["FULLSCREEN"] = "FULLSCREEN";
    PlaybackEvent["LIGHT_CONTENT"] = "LIGHT_CONTENT";
    PlaybackEvent["VIDEO_PAUSE"] = "VIDEO_PAUSE";
    PlaybackEvent["VIDEO_UNPAUSE"] = "VIDEO_UNPAUSE";
    PlaybackEvent["VIDEO_ENDED"] = "VIDEO_ENDED";
})(PlaybackEvent || (PlaybackEvent = {}));
//# sourceMappingURL=PlaybackEvent.js.map